<template>
    <div class="wrapper blog-post">
        <div class="page-header page-header-small" v-if="!headerSimple">
            <parallax class="page-header-image" v-bind:style="{ backgroundImage: 'url(' + mensaje('img1') + ')' }"></parallax>
            
            <div class="content-center">
                <div class="row">
                    <div class="col-md-8 ml-auto mr-auto text-center mt-5">
                        <h2 class="title">{{mensaje('tit1')}}</h2>
                        <span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(10%,-100%); line-height: normal;">nosotros.json->mensajes:tit1</span>
                        <h4>{{mensaje('tit2')}}</h4>
                        <span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(10%,-100%); line-height: normal;">nosotros.json->mensajes:tit2</span>
                    </div>
                </div>
            </div>
        </div>
        <span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(200%,-300%); line-height: normal;">nosotros.json->mensajes:img1</span>
        
        <div class="page-head2 page-header-mini" v-if="headerSimple" :style="{ marginBottom: `${logo_altura}px` }">
        </div>
        
        <div class="section">
            <div class="section">
                <div class="container">
                    <div class="row">
                        <div class="col-md-8 ml-auto mr-auto">
                            <h3 class="title">{{mensaje('tit3')}}</h3>
                            <span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(10%,-150%); line-height: normal;">nosotros.json->mensajes:tit3</span>
                            <p  v-html="mensaje('men1')"></p>
                            <span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(10%,-100%); line-height: normal;">nosotros.json->mensajes:men1 <i>HTML</i></span>
                            <p class="blockquote blockquote-primary" v-if="mensaje('com1').activo==true">
                                {{mensaje('com1').comentario}}
                                <span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(-10%,-10%); line-height: normal;">nosotros.json->mensajes:com1:comentario</span>
                                <br>
                                <br>
                                <small>
                                    {{mensaje('com1').cliente}}
                                    <span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(-10%,-10%); line-height: normal;">nosotros.json->mensajes:com1:cliente</span>
                                </small>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="section section-blog col-md-10 ml-auto mr-auto">
                <div class="container">
                    <div class="section-story-overview">
                        <div class="row">
                            <div class="col-md-6">
                                <div class="image-container image-left" v-bind:style="{ backgroundImage: 'url(' + mensaje('img2') + ')' }">
                                  <span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(10%,-10%); line-height: normal;">nosotros.json->mensajes:img2</span>
                                    <!-- First image on the left side -->
                                    <p class="blockquote blockquote-primary" v-if="mensaje('com2').activo==true">{{mensaje('com2').comentario}}
                                      <span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(10%,-10%); line-height: normal;">nosotros.json->mensajes:com2:comentario</span>
                                        <br>
                                        <br>
                                        <small>{{mensaje('com2').cliente}}</small>
                                        <span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(10%,-10%); line-height: normal;">nosotros.json->mensajes:com2:cliente</span>
                                        
                                    </p>
                                </div>
                                <!-- Second image on the left side of the article -->
                                <div class="image-container image-left-bottom"
                                     v-bind:style="{ backgroundImage: 'url(' + mensaje('img3') + ')' }">
                                     <span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(10%,-10%); line-height: normal;">nosotros.json->mensajes:img3</span>
                                </div>
                            </div>
                            <div class="col-md-5">
                                <!-- First image on the right side, above the article -->
                                <div class="image-container image-right"
                                     v-bind:style="{ backgroundImage: 'url(' + mensaje('img4') + ')' }">
                                     <span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(10%,-10%); line-height: normal;">nosotros.json->mensajes:img4</span>
                                </div>
                                <h3>{{mensaje('tit4')}}</h3>
                                <span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(10%,-150%); line-height: normal;">nosotros.json->mensajes:tit4</span>
                                <span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(10%,30%); line-height: normal;">nosotros.json->mensajes:men4 <i>HTML</i></span>
                                <p v-html="mensaje('men4')">
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="section">
                <div class="container">
                    <div class="row">
                        <div class="col-md-8 ml-auto mr-auto">
                            <h3 class="title">{{mensaje('tit5')}}</h3>
                            <span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(10%,-150%); line-height: normal;">nosotros.json->mensajes:tit5</span>
                            <span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(10%,30%); line-height: normal;">nosotros.json->mensajes:men5 <i>HTML</i></span>
                            <p v-html="mensaje('men5')"></p>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
  import { Card, Button, Comment, Badge, InfoSection, Checkbox } from '@/components';
  import {RUTA_BASE} from '@/constants'
  import axios from "axios"

  export default {
    name: 'nosotros',
    bodyClass: 'blog-post',
    components: {
      Card,
      InfoSection,
      Badge,
      Comment,
      [Button.name]: Button,
      [Checkbox.name]: Checkbox
    },
    data() {
      return {
        mensajes: [],
        headerSimple: false,
        logo_altura: 0,

      }
    },
    watch: {
      '$store.state.idioma': {
        handler(newValue, oldValue) {
          // Acciones a realizar cuando la variable cambia
          console.log('La variable ha cambiado', newValue)
          this.cambiaIdioma(newValue)
        },
        deep: true, // Opcional: vigila cambios profundos en la variable
      },
    },
    methods: {
      cambiaIdioma(nuevoValor) {
        var numIdioma = this.$store.state.idiomas[nuevoValor]
        var cadJson = 'json/nosotros'+numIdioma.toString()+'.json'
        axios.get(RUTA_BASE+cadJson)
        .then(response => {
          this.mensajes = response.data.mensajes
        })
        .catch(error => console.log(error))
      },
      mensaje(nom) {
        var mens = ''
        this.mensajes.forEach(elemento => {
          if (elemento.nombre==nom) {
            mens = elemento.mensaje
          }
        })
        return(mens)
      }
    },
    mounted() {
      var numIdioma = this.$store.state.idiomas[this.$store.state.idioma]
      this.headerSimple = this.$store.state.header_simple
      this.logo_altura = this.$store.state.logo_altura
      var cadJson = 'json/nosotros'+numIdioma.toString()+'.json'
      axios.get(RUTA_BASE+cadJson)
      .then(response => {
          this.mensajes = response.data.mensajes
      })
      .catch(error => console.log(error))
    }
  }
</script>
<style>
</style>
